/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// @ts-ignore
import * as runtime from '../runtime';
// @ts-ignore
import type {
// @ts-ignore
  BillingDetails,
// @ts-ignore
  BillingDetailsUpdateRequest,
// @ts-ignore
  BillingInfo,
// @ts-ignore
  BillingPricingListResponse,
// @ts-ignore
  ErrorResponse,
// @ts-ignore
  GenerateInvoicesResponse,
// @ts-ignore
  Invoice,
// @ts-ignore
  InvoiceListResponse,
// @ts-ignore
  InvoiceStatus,
// @ts-ignore
  InvoiceTransaction,
// @ts-ignore
  InvoiceTransactionListResponse,
// @ts-ignore
  InvoiceTransactionStatus,
// @ts-ignore
  ProcessInvoiceTransactionRequest,
// @ts-ignore
  ProcessInvoiceTransactionsRequest,
// @ts-ignore
  ProcessInvoiceTransactionsResponse,
// @ts-ignore
  UpdateInvoiceRequest,
// @ts-ignore
  UpdateSubscriptionRequest,
} from '../models/index';
// @ts-ignore
import {
// @ts-ignore
    BillingDetailsFromJSON,
// @ts-ignore
    BillingDetailsToJSON,
// @ts-ignore
    BillingDetailsUpdateRequestFromJSON,
// @ts-ignore
    BillingDetailsUpdateRequestToJSON,
// @ts-ignore
    BillingInfoFromJSON,
// @ts-ignore
    BillingInfoToJSON,
// @ts-ignore
    BillingPricingListResponseFromJSON,
// @ts-ignore
    BillingPricingListResponseToJSON,
// @ts-ignore
    ErrorResponseFromJSON,
// @ts-ignore
    ErrorResponseToJSON,
// @ts-ignore
    GenerateInvoicesResponseFromJSON,
// @ts-ignore
    GenerateInvoicesResponseToJSON,
// @ts-ignore
    InvoiceFromJSON,
// @ts-ignore
    InvoiceToJSON,
// @ts-ignore
    InvoiceListResponseFromJSON,
// @ts-ignore
    InvoiceListResponseToJSON,
// @ts-ignore
    InvoiceStatusFromJSON,
// @ts-ignore
    InvoiceStatusToJSON,
// @ts-ignore
    InvoiceTransactionFromJSON,
// @ts-ignore
    InvoiceTransactionToJSON,
// @ts-ignore
    InvoiceTransactionListResponseFromJSON,
// @ts-ignore
    InvoiceTransactionListResponseToJSON,
// @ts-ignore
    InvoiceTransactionStatusFromJSON,
// @ts-ignore
    InvoiceTransactionStatusToJSON,
// @ts-ignore
    ProcessInvoiceTransactionRequestFromJSON,
// @ts-ignore
    ProcessInvoiceTransactionRequestToJSON,
// @ts-ignore
    ProcessInvoiceTransactionsRequestFromJSON,
// @ts-ignore
    ProcessInvoiceTransactionsRequestToJSON,
// @ts-ignore
    ProcessInvoiceTransactionsResponseFromJSON,
// @ts-ignore
    ProcessInvoiceTransactionsResponseToJSON,
// @ts-ignore
    UpdateInvoiceRequestFromJSON,
// @ts-ignore
    UpdateInvoiceRequestToJSON,
// @ts-ignore
    UpdateSubscriptionRequestFromJSON,
// @ts-ignore
    UpdateSubscriptionRequestToJSON,
} from '../models/index';

export interface GetBillingDetailsRequest {
    storeId?: string;
    supplierId?: string;
    retailerId?: string;
}

export interface GetBillingInfoRequest {
    storeId?: string;
    supplierId?: string;
    retailerId?: string;
}

export interface GetBillingPricingRequest {
    storeId?: string;
    supplierId?: string;
    retailerId?: string;
}

export interface GetInvoiceRequest {
    id: string;
}

export interface GetInvoiceTransactionRequest {
    id: string;
}

export interface ListInvoiceTransactionsRequest {
    invoiceId?: string;
    status?: InvoiceTransactionStatus;
    limit?: number;
    offset?: number;
}

export interface ListInvoicesRequest {
    subscriptionId?: string;
    status?: InvoiceStatus;
    limit?: number;
    offset?: number;
}

export interface ProcessInvoiceTransactionOperationRequest {
    id: string;
    processInvoiceTransactionRequest?: ProcessInvoiceTransactionRequest;
}

export interface ProcessInvoiceTransactionsOperationRequest {
    processInvoiceTransactionsRequest?: ProcessInvoiceTransactionsRequest;
}

export interface UpdateBillingDetailsRequest {
    billingDetailsUpdateRequest: BillingDetailsUpdateRequest;
}

export interface UpdateInvoiceOperationRequest {
    id: string;
    updateInvoiceRequest: UpdateInvoiceRequest;
}

export interface UpdateSubscriptionOperationRequest {
    updateSubscriptionRequest: UpdateSubscriptionRequest;
}

/**
 * 
 */
export class BillingApi extends runtime.BaseAPI {

    /**
     * Generates pending invoice transactions for invoices without transactions yet.
     * Generate invoice transactions
     */
    async generateInvoiceTransactionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GenerateInvoicesResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/billing/invoice-transactions/generate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GenerateInvoicesResponseFromJSON(jsonValue));
    }

    /**
     * Generates pending invoice transactions for invoices without transactions yet.
     * Generate invoice transactions
     */
    async generateInvoiceTransactions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GenerateInvoicesResponse> {
        const response = await this.generateInvoiceTransactionsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Generates invoices for billing subscriptions that are due for the current billing period.
     * Generate invoices
     */
    async generateInvoicesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GenerateInvoicesResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/billing/invoices/generate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GenerateInvoicesResponseFromJSON(jsonValue));
    }

    /**
     * Generates invoices for billing subscriptions that are due for the current billing period.
     * Generate invoices
     */
    async generateInvoices(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GenerateInvoicesResponse> {
        const response = await this.generateInvoicesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Returns billing contact and legal details used for invoicing and tax. System admins may provide exactly one of `store_id`, `supplier_id`, or `retailer_id` to retrieve another billing customer\'s details; when omitted, the authenticated user\'s billing customer is used.
     * Get billing details
     */
    async getBillingDetailsRaw(requestParameters: GetBillingDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BillingDetails>> {
        const queryParameters: any = {};

        if (requestParameters.storeId !== undefined) {
            queryParameters['store_id'] = requestParameters.storeId;
        }

        if (requestParameters.supplierId !== undefined) {
            queryParameters['supplier_id'] = requestParameters.supplierId;
        }

        if (requestParameters.retailerId !== undefined) {
            queryParameters['retailer_id'] = requestParameters.retailerId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/billing/details`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BillingDetailsFromJSON(jsonValue));
    }

    /**
     * Returns billing contact and legal details used for invoicing and tax. System admins may provide exactly one of `store_id`, `supplier_id`, or `retailer_id` to retrieve another billing customer\'s details; when omitted, the authenticated user\'s billing customer is used.
     * Get billing details
     */
    async getBillingDetails(requestParameters: GetBillingDetailsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BillingDetails> {
        const response = await this.getBillingDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns current plan status, billing cycle, payment method summary, billing details, and invoice settings. System admins may provide exactly one of `store_id`, `supplier_id`, or `retailer_id` to retrieve another billing customer\'s information; when omitted, the authenticated user\'s billing customer is used.
     * Get billing information
     */
    async getBillingInfoRaw(requestParameters: GetBillingInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BillingInfo>> {
        const queryParameters: any = {};

        if (requestParameters.storeId !== undefined) {
            queryParameters['store_id'] = requestParameters.storeId;
        }

        if (requestParameters.supplierId !== undefined) {
            queryParameters['supplier_id'] = requestParameters.supplierId;
        }

        if (requestParameters.retailerId !== undefined) {
            queryParameters['retailer_id'] = requestParameters.retailerId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/billing`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BillingInfoFromJSON(jsonValue));
    }

    /**
     * Returns current plan status, billing cycle, payment method summary, billing details, and invoice settings. System admins may provide exactly one of `store_id`, `supplier_id`, or `retailer_id` to retrieve another billing customer\'s information; when omitted, the authenticated user\'s billing customer is used.
     * Get billing information
     */
    async getBillingInfo(requestParameters: GetBillingInfoRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BillingInfo> {
        const response = await this.getBillingInfoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns the read-only pricing configuration grouped by billing owner type. When `store_id`, `supplier_id`, or `retailer_id` is provided, the response contains pricing for that owner type only. When omitted, the response contains pricing for all owner types.
     * Get billing pricing
     */
    async getBillingPricingRaw(requestParameters: GetBillingPricingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BillingPricingListResponse>> {
        const queryParameters: any = {};

        if (requestParameters.storeId !== undefined) {
            queryParameters['store_id'] = requestParameters.storeId;
        }

        if (requestParameters.supplierId !== undefined) {
            queryParameters['supplier_id'] = requestParameters.supplierId;
        }

        if (requestParameters.retailerId !== undefined) {
            queryParameters['retailer_id'] = requestParameters.retailerId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/billing/pricing`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BillingPricingListResponseFromJSON(jsonValue));
    }

    /**
     * Returns the read-only pricing configuration grouped by billing owner type. When `store_id`, `supplier_id`, or `retailer_id` is provided, the response contains pricing for that owner type only. When omitted, the response contains pricing for all owner types.
     * Get billing pricing
     */
    async getBillingPricing(requestParameters: GetBillingPricingRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BillingPricingListResponse> {
        const response = await this.getBillingPricingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns one invoice by id.
     * Get invoice
     */
    async getInvoiceRaw(requestParameters: GetInvoiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Invoice>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getInvoice.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/billing/invoices/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvoiceFromJSON(jsonValue));
    }

    /**
     * Returns one invoice by id.
     * Get invoice
     */
    async getInvoice(requestParameters: GetInvoiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Invoice> {
        const response = await this.getInvoiceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns one invoice transaction by id.
     * Get invoice transaction
     */
    async getInvoiceTransactionRaw(requestParameters: GetInvoiceTransactionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InvoiceTransaction>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getInvoiceTransaction.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/billing/invoice-transactions/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvoiceTransactionFromJSON(jsonValue));
    }

    /**
     * Returns one invoice transaction by id.
     * Get invoice transaction
     */
    async getInvoiceTransaction(requestParameters: GetInvoiceTransactionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InvoiceTransaction> {
        const response = await this.getInvoiceTransactionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Lists invoice transactions with optional filters.
     * List invoice transactions
     */
    async listInvoiceTransactionsRaw(requestParameters: ListInvoiceTransactionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InvoiceTransactionListResponse>> {
        const queryParameters: any = {};

        if (requestParameters.invoiceId !== undefined) {
            queryParameters['invoiceId'] = requestParameters.invoiceId;
        }

        if (requestParameters.status !== undefined) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/billing/invoice-transactions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvoiceTransactionListResponseFromJSON(jsonValue));
    }

    /**
     * Lists invoice transactions with optional filters.
     * List invoice transactions
     */
    async listInvoiceTransactions(requestParameters: ListInvoiceTransactionsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InvoiceTransactionListResponse> {
        const response = await this.listInvoiceTransactionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Lists invoices with optional filters.
     * List invoices
     */
    async listInvoicesRaw(requestParameters: ListInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InvoiceListResponse>> {
        const queryParameters: any = {};

        if (requestParameters.subscriptionId !== undefined) {
            queryParameters['subscriptionId'] = requestParameters.subscriptionId;
        }

        if (requestParameters.status !== undefined) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/billing/invoices`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvoiceListResponseFromJSON(jsonValue));
    }

    /**
     * Lists invoices with optional filters.
     * List invoices
     */
    async listInvoices(requestParameters: ListInvoicesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InvoiceListResponse> {
        const response = await this.listInvoicesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Charges the payment method configured on an invoice transaction and updates its status.
     * Process invoice transaction
     */
    async processInvoiceTransactionRaw(requestParameters: ProcessInvoiceTransactionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InvoiceTransaction>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling processInvoiceTransaction.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/billing/invoice-transactions/{id}/process`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProcessInvoiceTransactionRequestToJSON(requestParameters.processInvoiceTransactionRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvoiceTransactionFromJSON(jsonValue));
    }

    /**
     * Charges the payment method configured on an invoice transaction and updates its status.
     * Process invoice transaction
     */
    async processInvoiceTransaction(requestParameters: ProcessInvoiceTransactionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InvoiceTransaction> {
        const response = await this.processInvoiceTransactionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Processes pending invoice transactions. Calling this endpoint again continues with remaining pending transactions. Set `retry_failed` in the request body to also reset and reprocess failed transactions using the current invoice amount. Transaction-specific failures are returned in the response and do not stop the remaining processable transactions from being processed.
     * Process invoice transactions
     */
    async processInvoiceTransactionsRaw(requestParameters: ProcessInvoiceTransactionsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProcessInvoiceTransactionsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/billing/invoice-transactions/process`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProcessInvoiceTransactionsRequestToJSON(requestParameters.processInvoiceTransactionsRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProcessInvoiceTransactionsResponseFromJSON(jsonValue));
    }

    /**
     * Processes pending invoice transactions. Calling this endpoint again continues with remaining pending transactions. Set `retry_failed` in the request body to also reset and reprocess failed transactions using the current invoice amount. Transaction-specific failures are returned in the response and do not stop the remaining processable transactions from being processed.
     * Process invoice transactions
     */
    async processInvoiceTransactions(requestParameters: ProcessInvoiceTransactionsOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProcessInvoiceTransactionsResponse> {
        const response = await this.processInvoiceTransactionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates billing contact/company details used for invoices and tax. System admins may provide a customer to update any billing customer\'s details; when omitted, the authenticated user\'s billing customer is used.
     * Update billing details
     */
    async updateBillingDetailsRaw(requestParameters: UpdateBillingDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BillingDetails>> {
        if (requestParameters.billingDetailsUpdateRequest === null || requestParameters.billingDetailsUpdateRequest === undefined) {
            throw new runtime.RequiredError('billingDetailsUpdateRequest','Required parameter requestParameters.billingDetailsUpdateRequest was null or undefined when calling updateBillingDetails.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/billing/details`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: BillingDetailsUpdateRequestToJSON(requestParameters.billingDetailsUpdateRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BillingDetailsFromJSON(jsonValue));
    }

    /**
     * Updates billing contact/company details used for invoices and tax. System admins may provide a customer to update any billing customer\'s details; when omitted, the authenticated user\'s billing customer is used.
     * Update billing details
     */
    async updateBillingDetails(requestParameters: UpdateBillingDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BillingDetails> {
        const response = await this.updateBillingDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates an existing invoice with corrected values for rectification purposes.
     * Update invoice
     */
    async updateInvoiceRaw(requestParameters: UpdateInvoiceOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateInvoice.');
        }

        if (requestParameters.updateInvoiceRequest === null || requestParameters.updateInvoiceRequest === undefined) {
            throw new runtime.RequiredError('updateInvoiceRequest','Required parameter requestParameters.updateInvoiceRequest was null or undefined when calling updateInvoice.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/billing/invoices/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateInvoiceRequestToJSON(requestParameters.updateInvoiceRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Updates an existing invoice with corrected values for rectification purposes.
     * Update invoice
     */
    async updateInvoice(requestParameters: UpdateInvoiceOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateInvoiceRaw(requestParameters, initOverrides);
    }

    /**
     * Updates the subscription for the current billing customer. System admins may provide a customer to update any billing customer\'s subscription and may set a subscription start date in the past.
     * Update subscription
     */
    async updateSubscriptionRaw(requestParameters: UpdateSubscriptionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BillingInfo>> {
        if (requestParameters.updateSubscriptionRequest === null || requestParameters.updateSubscriptionRequest === undefined) {
            throw new runtime.RequiredError('updateSubscriptionRequest','Required parameter requestParameters.updateSubscriptionRequest was null or undefined when calling updateSubscription.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/billing/subscription`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateSubscriptionRequestToJSON(requestParameters.updateSubscriptionRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BillingInfoFromJSON(jsonValue));
    }

    /**
     * Updates the subscription for the current billing customer. System admins may provide a customer to update any billing customer\'s subscription and may set a subscription start date in the past.
     * Update subscription
     */
    async updateSubscription(requestParameters: UpdateSubscriptionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BillingInfo> {
        const response = await this.updateSubscriptionRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
